/**
 * BackLink — приглушённая текст-кнопка «назад/отмена». Раскладка (отступы, ширина) — через className.
 */
import type { ReactNode } from "react";

export function BackLink({
  children,
  onClick,
  className = "",
}: {
  children: ReactNode;
  onClick: () => void;
  className?: string;
}) {
  return (
    <button onClick={onClick} className={`text-[14px] text-white/45 active:opacity-70 ${className}`}>
      {children}
    </button>
  );
}
